// @flow
import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import VideoModal from './VideoModal';

import PlayIcon from '../../../../assets/img/home/how-it-works/play-icon.png';

import style from './Discover.scss';
import icons from '../../../../assets/styles/icons.scss';

type Props = {
  +color?: 'white' | 'lightBlue' | 'orange' | 'green';
  +url: string;
  +text?: string;
  +handleClick?: () => void;
  +hasIcon?: boolean;
};

type State = {
  modalVisible: boolean;
};

export default class Discover extends Component<Props, State> {

  state = {
    modalVisible: false,
  };

  static defaultProps = {
    color: 'white',
    hasIcon: true,
  };

  handleOpenModal = () => {
    const { handleClick } = this.props;
    if (!this.state.modalVisible ) {
      if (handleClick) {
        handleClick();
      }
      this.setState({ modalVisible: true });
    }
  };

  handleCloseModal = () => {
    this.setState({ modalVisible: false });
  };

  render() {
    const { color, url, text } = this.props;
    const { modalVisible } = this.state;

    return ( 
      <div className={classNames(style.discover, style[color])}
              onClick={this.handleOpenModal}>  
        <div className={style.buttonWrap}>
          <img width={19} height={19} src={PlayIcon} alt="play-icon" />
          Ver Video
        </div>
        <VideoModal handleClose={this.handleCloseModal}
                    modalVisible={modalVisible}
                    url={url}/> 
      </div> 
    );
  }
}

Discover.propTypes = {
  color: PropTypes.string,
  url: PropTypes.string.isRequired,
  text: PropTypes.string,
  handleClick: PropTypes.func,
  hasIcon: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/home/elements/Discover/Discover.jsx